import Nullstack from 'nullstack';
export default function IconDialpad({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-dialpad",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 3h4v4h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M17 3h4v4h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M10 3h4v4h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M3 10h4v4h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M17 10h4v4h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M10 10h4v4h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M10 17h4v4h-4z"
  }), " ");
}